import React from "react";
import logoIcon from "../../assets/images/bytemonk-logo-only.svg";
import logoText from "../../assets/images/bytemonk-text-only.svg";
import Instagram from "../../assets/images/instagram-icon.webp";
import Linkedin from "../../assets/images/linkedin-icon.webp";
import Email from "../../assets/images/email-icon.webp";
import Discord from "../../assets/images/discord-icon.webp";
import Location from "../../assets/images/location-icon.webp";

const Footer: React.FC = () => {
  return (
    <footer
      className="text-white mt-5"
      style={{
        padding: "30px 20px",
        backgroundColor: "black",
        fontFamily: "'Quantico', sans-serif",
      }}
    >
      <div className="container">
        <div className="d-block d-md-flex justify-content-between gap-4">
          {/* Left Section */}
          <div className="mb-4" style={{ flex: "1" }}>
            <div className="d-flex align-items-center mb-3">
              <img
                src={logoIcon}
                alt="ByteMonk Icon"
                width="40"
                height="40"
                style={{ width: "40px", marginRight: "10px" }}
              />
              <img
                src={logoText}
                alt="ByteMonk Text"
                width="130"
                height="20"
                style={{ width: "130px", height: "20px" }}
              />
            </div>
            <p
              className="text-light"
              style={{ lineHeight: "1.6", fontSize: "0.95rem" }}
            >
              ByteMonk is the official technology club of GCECT, fostering a
              culture of innovation through events, workshops, and student-led
              projects in fields like coding, AI, robotics, cybersecurity, and
              more.
            </p>
            <p className="text-light" style={{ fontSize: "0.85rem", opacity: 0.65 }}>
              &#169; 2025 ByteMonk. All rights reserved.
            </p>
          </div>

          {/* Right Section */}
          <div style={{ flex: "1" }}>
            <p
              className="mb-3 text-start fw-bold"
              style={{
                fontFamily: "'Orbitron', sans-serif",
                fontSize: "1.3rem",
              }}
            >
              Follow us on
            </p>

            {/* Social Icons */}
            <div className="d-flex gap-3 mb-3 flex-wrap ps-1">
              <a
                href="https://www.instagram.com/gcect.tech.club/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={Instagram}
                  alt="ByteMonk Instagram"
                  width="36"
                  height="36"
                  loading="lazy"
                  style={{ width: "36px", height: "36px", borderRadius: "50%" }}
                />
              </a>
              <a
                href="https://www.linkedin.com/company/Bytemonk/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={Linkedin}
                  alt="ByteMonk LinkedIn"
                  width="36"
                  height="36"
                  loading="lazy"
                  style={{ width: "36px", height: "36px", borderRadius: "50%" }}
                />
              </a>
              <a
                href="https://discord.gg/CewFGJSyFC"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={Discord}
                  alt="ByteMonk Discord"
                  width="36"
                  height="36"
                  loading="lazy"
                  style={{ width: "36px", height: "36px", borderRadius: "50%" }}
                />
              </a>
            </div>

            {/* Email */}
            <div className="mb-3 d-flex align-items-center flex-wrap">
              <img
                src={Email}
                alt="Email Icon"
                width="28"
                height="28"
                loading="lazy"
                style={{ width: "28px", height: "28px", borderRadius: "50%" }}
              />
              <a
                href="mailto:gcect.technologyclub@gmail.com"
                className="ms-2 text-decoration-none text-light"
                style={{ fontSize: "0.95rem", wordBreak: "break-word" }}
              >
                gcect.technologyclub@gmail.com
              </a>
            </div>

            {/* Location */}
            <div className="mb-3 d-flex align-items-center flex-wrap">
              <img
                src={Location}
                alt="Location Icon"
                width="28"
                height="28"
                loading="lazy"
                style={{ width: "28px", height: "28px", borderRadius: "50%" }}
              />
              <a
                href="https://maps.app.goo.gl/Afe2KxpMHBgryxT4A"
                target="_blank"
                rel="noopener noreferrer"
                className="ms-2 text-decoration-none text-light"
                style={{ fontSize: "0.95rem" }}
              >
                <span>
                  73, Abinash Chandra Banerjee Ln,
                  <br className="d-md-none" />
                  Kolkata-700010
                </span>
              </a>
            </div>

            {/* Map Link */}
            <div className="text-start">
              <a
                href="https://maps.app.goo.gl/Afe2KxpMHBgryxT4A"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none text-light"
                aria-label="See location on Google Maps"
                style={{ fontSize: "0.9rem" }}
              >
                SEE ON MAP ↗
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
